// extracted by mini-css-extract-plugin
export default {"wrapper":"TagBox_wrapper__-OIR2","dark":"TagBox_dark__sqH7D"};